// extracted by mini-css-extract-plugin
export default {"team_title":"TeamTitle_team_title__Ju7mn","frame":"TeamTitle_frame__HqS4W"};